export const environment = {
  production: false,
  hostUrl: 'https://uat-asiatique.vthgdigital.com',
  apiUrl: 'https://uat-asiatique.vthgdigital.com/api/',
  appSecret: 'XD3k6BGUTQ/SinyNXRXLvg8Qy+dxjt1Ol5XwO9VonbE=',
  salt: 'e886549e0faf299e2c2f427c3fbc2462',
};
